import { Component, OnInit } from '@angular/core';
import { Constant } from '../../../../constants/constant';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AboutService } from '../../../services/about.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DefaultLayoutDirective } from '../../../flex-layout/custom-layout';
import { DefaultFlexDirective } from '../../../flex-layout/flex';
import { DefaultClassDirective } from '../../../flex-layout/class';
import { MatError } from '@angular/material/form-field';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'calsoft-subscriber-button3',
  imports: [FormsModule, DefaultLayoutDirective, DefaultFlexDirective, DefaultClassDirective, ReactiveFormsModule, MatError, MatButton],
  templateUrl: './subscriber-button3.component.html',
  styleUrl: './subscriber-button3.component.scss'
})
export class SubscriberButton3Component implements OnInit {
  firstFormGroup: UntypedFormGroup | any;
  constructor( public formBuilder: UntypedFormBuilder,
    public snackBar: MatSnackBar,
    private aboutService: AboutService,) { }

  ngOnInit(): void {
    this.firstFormGroup = this.formBuilder.group({
      'subscriberId': ['',],
      'storeId': ['',],
      'changeStatusAt': ['',],
      'customerId': ['',],
      'subscriberEmail': ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
      'subscriberStatus': ['',],
      'subscriberConfirmCode': ['',],
    });
  }
  subscribe() {
    this.firstFormGroup.value.storeId = 1;
    this.firstFormGroup.value.subscriberStatus = 1;
    this.firstFormGroup.value.operationType = "New";

    if(this.firstFormGroup.valid){
      this.aboutService.subscriper(this.firstFormGroup.value).subscribe(
        (response:any) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
            this.firstFormGroup.reset();
          } else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
          }
        },
        (err: any) => { });
    }else{
      this.snackBar.open('Please fill out this field.', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
    }
    
  }


}